import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { Ref } from "vue";

import { toastKiliError } from "@/data/api/kili/common/toast-kili-error";
import {
  ConsumptionMutationKeys,
  ConsumptionQueryKeys,
  EConsumptionQueryAction,
} from "@/data/api/kili/consumption/consumption-query-keys";
import { TEditSiteConsumptionInfosBody } from "@/data/api/kili/consumption/types/consumption-infos.type";
import KiliApi from "@/data/api/kili/kili-api";
import { hasAtLeastKeyPart } from "@/utils/libs/tanstack-utils";

export interface IEditSiteConsumptionInfosCommand {
  siteId: Ref<number>;
  body: TEditSiteConsumptionInfosBody;
}

export function useEditSiteConsumptionInfosMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ConsumptionMutationKeys.editSiteConsumptionInformations(),
    mutationFn: async (command: IEditSiteConsumptionInfosCommand) => {
      return await KiliApi.editSiteConsumptionInformations(command.body, { params: { siteId: command.siteId.value } });
    },
    onError: (e) => {
      toastKiliError(e);
    },
    onSettled: async (_, __, command) => {
      await queryClient.invalidateQueries({
        queryKey: ConsumptionQueryKeys.siteConsumptionInformations(command.siteId),
      });

      await queryClient.removeQueries({
        predicate: hasAtLeastKeyPart({ action: EConsumptionQueryAction.FIND_DSO_CONSUMPTION }),
        type: "all",
      });

      await queryClient.removeQueries({
        predicate: hasAtLeastKeyPart({ action: EConsumptionQueryAction.FIND_MISSING_INFOS }),
        type: "all",
      });
    },
  });
}
